/**
 * 描述：稿件背景指令
 * 日期：2017-10-18
 * 作者：Bai.Zhiming
 */
'use strict';
angular.module('docBackgroundModule', ["calcMaxlinumModule"]).
directive('scDocBackground', ['$timeout', 'alterModule', 'trsHttpService', function($timeout, alterModule, trsHttpService) {
    return {
        replace: true,
        restrict: 'E',
        transclude: false,
        templateUrl: './editingCenter/directive/supportCreation/docBackground/docBackground_tpl.html',
        scope: false,
        link: function(scope, $elem, $attrs) {
            var ue = UE.getEditor('ueditor');
            var content;
            initStatus();
            initData();
            /**
             * [initStatus description] 初始化状态
             * @return {[type]} [description]
             */
            function initStatus() {
                scope.status = {
                    isSelectedName: false,
                    isSelectedOrganization: false,
                    isSelectedPlace: false,
                    isSelectedKeyWords: false,
                    backmeanu: {
                        // params: "",
                        // items: [],
                        page: "",
                        modelid: "backmeanuScripts",
                        selectedName: [],
                        selectedOrganization: [],
                        selectedPlace: [],
                        selectedKeyWords: [],
                        selectedNameLen: '',
                        selectedOrganizationLen: '',
                        selectedPlaceLen: '',
                        selectedKeyWordsLen: '',
                    },
                    message: {
                        backmeanuHasNoMore: false
                    },
                    page: {
                        backmeanu: {
                            CURRPAGE: 1,
                            PAGESIZE: 5,
                            PAGECOUNT: ""
                        }
                    }
                };
                scope.data = {
                    keyWords: {
                        maxlinum: ''
                    }
                };
                // var page = {
                //     backmeanu: {
                //         CURRPAGE: 1,
                //         PAGESIZE: 5,
                //         PAGECOUNT: ""
                //     }
                // };
                // var message = {
                //     backmeanuHasNoMore: true
                // };
                // angular.extend(scope.status, status);
                // angular.extend(scope.status.page, page);
                // angular.extend(scope.status.message, message);
                scope.status.backmeanu.params = {
                    name: [],
                    place: [],
                    organization: [],
                    keyWords: []
                };
                ue.addListener("contentChange", function() { //实时双向绑定开始
                    content = ue.getContentTxt();
                    updateData(content);
                });
                delete scope.status.backmeanu.items; //预先删除 防止在出现蒙层的时候页面显示没有更多了
            }
            /**
             * [updateSelectedItems description：打开新窗口]
             * @param  {[type]} item      [description：被点击的对象]
             * @param  {[type]} indexname      [description：当前对象名称（因为在不同的表，所以单独处理）]
             */
            scope.windowOpen = function(item, indexname) {
                alterModule.alterDeatil(item, indexname);
            };
            /**
             * [updateData description] 更新数据
             * @param  {[type]} content [description]
             * @return {[type]}         [description]
             */
            function updateData(content) {
                var content_ = content.replace(/\n/g, "");
                if (content_ !== "" && content_.length >= 20) {
                    queryBackmeanuParams(false);
                    queryBackmeanu(false);
                } else {
                    scope.status.backmeanu.items = [];
                }
            }
            /**
             * [updateSelectedItems description：更新选中的对象,并按照筛选条件加载稿件背景]
             * @param  {[type]} item      [description：被点击的对象]
             * @param  {[type]} itemsName [description：该对象所在集合]
             */

            scope.updateSelectedItems = function(item, itemsName) {
                var index = scope.status.backmeanu[itemsName].indexOf(item);
                if (index > -1) {
                    scope.status.backmeanu[itemsName].splice(index, 1);
                } else {
                    scope.status.backmeanu[itemsName].push(item);
                }
                scope.status.backmeanu.modelid = "searchBybackWords";
                queryBackmeanu();
            };
            //显示所有
            scope.showList = function() {
                scope.status.isSelectedName = !scope.status.isSelectedName;
            };
            /**
             * [initData description] 初始化数据
             * @return {[type]} [description]
             */
            function initData() {
                content = ue.getContentTxt();
                updateData(content);
            }
            var promiseA;
            //获取三维背景
            function queryBackmeanuParams() {
                if (promiseA) {
                    $timeout.cancel(promiseA);
                    promiseA = null;
                }
                $timeout(function() {
                    var params = {
                        typeid: "zyzx",
                        serviceid: "write",
                        modelid: "backWordsExtract",
                        content: content
                    };
                    //获取人名、地名、机构
                    scope.Backmeanu = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, "post").then(function(data) {
                        if (data === "" || data.result === "fail" || data.result === "warn") return;
                        initBackMeanu();
                        initBackMeanuPush(data);
                        initBackMeanuLen();

                    });
                }, 2000);
                return promiseA;
            }
            /**
             * [queryBackmeanu description：获取稿件背景 by content]
             * @param  {Boolean} isGetMore [description：判断是初始化还是加载更多，加载跟多则拼接数组]
             * @return {[type]}            [description]
             */
            var promiseC;

            function queryBackmeanu(isGetMore) {
                if (promiseC) {
                    $timeout.cancel(promiseC);
                    promiseC = null;
                }
                promiseC = $timeout(function() {
                    var params = {
                        typeid: "zyzx",
                        serviceid: "write",
                        modelid: scope.status.backmeanu.modelid,
                        content: content,
                        pageSize: scope.status.page.backmeanu.PAGESIZE,
                        pageNum: scope.status.page.backmeanu.CURRPAGE,
                        name: scope.status.backmeanu.selectedName.join(","),
                        place: scope.status.backmeanu.selectedPlace.join(","),
                        organization: scope.status.backmeanu.selectedOrganization.join(","),
                        keyWords: scope.status.backmeanu.selectedKeyWords.join(",")
                    };
                    scope.loadingSubject = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, "post").then(function(data) {
                        if (data === "" || data.result === "fail" || data.result === "warn") {
                            scope.status.backmeanu.items = [];
                            return;
                        }
                        $timeout(function() {
                            if (!!isGetMore) {
                                scope.status.backmeanu.items = scope.status.backmeanu.items.concat(data.content);

                            } else {
                                scope.status.backmeanu.items = data.content;
                            }
                            scope.status.page.backmeanu = data.summary_info;
                            scope.status.message.backmeanuHasNoMore = data.summary_info.CURRPAGE >= data.summary_info.PAGECOUNT;
                        });
                    });
                }, 1000);
                return promiseC;
            }
            //获取人名、地名、机构、关键词
            function initBackMeanuPush(data) {
                scope.status.backmeanu.params = data.content[0];
                scope.status.backmeanu.selectedName.push(data.content[0].name.length > 0 ? data.content[0].name[0] : "");
                scope.status.backmeanu.selectedOrganization.push(data.content[0].organization.length > 0 ? data.content[0].organization[0] : "");
                scope.status.backmeanu.selectedPlace.push(data.content[0].place.length > 0 ? data.content[0].place[0] : "");
                scope.status.backmeanu.selectedKeyWords.push(data.content[0].keyWords.length > 0 ? data.content[0].keyWords[0] : "");
            }
            //初始化人名 机构 地名
            function initBackMeanu() {
                scope.status.backmeanu.selectedName = [];
                scope.status.backmeanu.selectedOrganization = [];
                scope.status.backmeanu.selectedPlace = [];
                scope.status.backmeanu.selectedKeyWords = [];
            }
            //初始化稿件背景长度
            function initBackMeanuLen() {
                scope.status.backmeanu.selectedNameLen = scope.status.backmeanu.params.name.length;
                scope.status.backmeanu.selectedOrganizationLen = scope.status.backmeanu.params.organization.length;
                scope.status.backmeanu.selectedPlaceLen = scope.status.backmeanu.params.place.length;
                scope.status.backmeanu.selectedKeyWordsLen = scope.status.backmeanu.params.keyWords.length;
            }
            //加载更多稿件背景
            scope.getMoreBack = function() {
                if (scope.status.page.backmeanu.CURRPAGE >= scope.status.page.backmeanu.PAGECOUNT) {
                    return;
                }
                scope.status.page.backmeanu.CURRPAGE += 1;
                queryBackmeanu(true);
            };
        }
    };
}]);